import { render } from "./Pindai.vue?vue&type=template&id=2a6342fd&scoped=true"
import script from "./Pindai.vue?vue&type=script&lang=js"
export * from "./Pindai.vue?vue&type=script&lang=js"

import "./Pindai.vue?vue&type=style&index=0&id=2a6342fd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a6342fd"]])

export default __exports__